// Route Pages
const LinkAccount = () => import('../../../components/loans/pages/common/LinkAccount.vue')
const LinkAccountFailed = () => import('../../../components/loans/pages/common/LinkAccountFailed.vue')
const ReplaceAccount = () => import('../../../components/common/pages/ReplaceAccount.vue')

export default () => {
  return [
    {
      path: 'LinkAccount',
      name: 'LinkAccount',
      component: LinkAccount,
      props: true
    },
    {
      path: 'LinkAccountFailed',
      name: 'LinkAccountFailed',
      component: LinkAccountFailed,
      props: true
    },
    {
      path: 'ReplaceAccount',
      name: 'ReplaceAccount',
      component: ReplaceAccount,
      props: true
    }
  ]
}
